import React from "react";
// Components
import { Date, Search, SelectedVersions } from "./Components";

import { useParams } from "react-router-dom";
// Store Utils
import { useSelector } from "react-redux";
import { RootState } from "store";
import { useDispatch } from "react-redux";
import { pollAndSurveyResultsResetFiltersAction } from "store/filters/reducer.actions";
import {
  filtersInitialState,
  pollAndSurveyResultsDirectoryFilterState,
} from "store/filters/initialState";

const AppliedFilters = () => {
  const { pollAndSurveyResultsFilter } = useSelector<
    RootState,
    filtersInitialState
  >((state) => state.Filters);
  const dispatch = useDispatch();

  // Function to check if any filter is applied
  const isAnyFilterApplied = (
    pollAndSurveyResultsFilter: pollAndSurveyResultsDirectoryFilterState
  ): boolean => {
    const { responseDate } = pollAndSurveyResultsFilter;
    const applied = responseDate?.applied;
    return applied;
  };

  const clearAllFilters = () => {
    dispatch(pollAndSurveyResultsResetFiltersAction());
  };
  return (
    <div className="flex flex-wrap items-center justify-start gap-4 w-full">
      {isAnyFilterApplied(pollAndSurveyResultsFilter) && (
        <button
          onClick={clearAllFilters}
          type="button"
          className="flex items-center justify-center flex-grow-0 flex-shrink-0 gap-1 border-none outline-none focus:outline-none rounded-3xl"
        >
          <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative pt-1.5 pb-2">
            <p className="flex-grow-0 flex-shrink-0 text-sm font-semibold text-center text-primary">
              Clear All Filters
            </p>
          </div>
        </button>
      )}
      <div
        style={{ maxWidth: "90%" }}
        className="flex flex-wrap items-center justify-start"
      >
        <div className="flex flex-wrap gap-2">
          <Search />
          {/* <SelectedVersions /> */}

          <Date
            name="responseDate"
            from={pollAndSurveyResultsFilter.responseDate.from}
            to={pollAndSurveyResultsFilter.responseDate.to}
            isApplied={pollAndSurveyResultsFilter.responseDate?.applied}
          />
        </div>
      </div>
    </div>
  );
};

export default AppliedFilters;
